import React, { useState, useEffect } from 'react';
import { Button, DropdownButton, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Dropdown_jump = (props) => {
    const [value1, setValue1] = useState('');

    const regola_la_difficolta_della_domanda = (e) => {
        var date = new Date();
        var timestamp = Math.round(date.getTime() / 1000 / 60 | 0);
        var lista_file = props.lista_file_mp3
        //    console.log(e);
        lista_file[props.index2].indice_end += parseInt(e)
        if (lista_file[props.index2].indice_end < 1) {
            lista_file[props.index2].indice_end = 1
        }
        lista_file[props.index2].indice_aux = 0
        lista_file[props.index2].microtime_last = timestamp
        props.SET_lista_file_mp3(lista_file)
        console.log(lista_file[props.index2].indice_end);
        props.SET_aggiorna_lista(2)
        props.trova_mp3_per_play()
    }



    return (
        <div>




            <DropdownButton
                title="jump"
                onSelect={regola_la_difficolta_della_domanda} >
                <Dropdown.Item eventKey="+10">+10</Dropdown.Item>

                <Dropdown.Item eventKey="+5">+5</Dropdown.Item>
                <Dropdown.Item eventKey="0"> 0</Dropdown.Item>

                <Dropdown.Item eventKey="-2">-10</Dropdown.Item>
                <Dropdown.Item eventKey="-5">-20</Dropdown.Item>

            </DropdownButton>
        </div>
    )
}
export default Dropdown_jump;